export default __webpack_public_path__ + "static/media/flag-gambia.a9b7f29d.svg";